import React, {useEffect} from "react";
import { Row, Col, Typography, Button } from "antd";
import styled from "styled-components";
import mainimage from "../image/EXIM-Ship.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const { Title, Paragraph } = Typography;

const BannerContainer = styled.div`
  margin-top: 30px;
  padding: 50px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 30px;
    text-align: center;
  }
`;

const Image = styled.img`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

const ShopButton = styled(Button)`
  margin-top: 20px;
  border-radius: 20px;
  padding: 10px 20px;
  font-weight: bold;
  border: 2px solid #00a650;
  color: #00a650;

  &:hover {
    background: #00a650;
    color: white;
  }
`;

const Section3 = () => {
  const Functionscrooll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with a duration of 1000ms
  }, []);
  return (
    <BannerContainer>
      <Row gutter={[32, 32]} align="middle">
        {/* Image Column */}
        <Col xs={24} md={12} >
        <motion.div
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 1.0 }}
                className="motion-div"
                // data-aos="fade-up"
              >
          <Image src={mainimage} alt="Sunglasses" data-aos="fade-right" />
          </motion.div>
        </Col>

        {/* Text Content Column */}
        <Col xs={24} md={12}>
          <Title level={2}>About US</Title>
          <motion.div
                // whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 1.0 }}
                className="motion-div"
                data-aos="fade-up"
              >
          <Paragraph style={{ fontSize: "17px", fontFamily: "sans-serif" }} >
            {/* ✅ Hotel Industry – Builds trust, showcases luxury, attracts guests,
            and highlights unique services.
            <br />
            ✅ Export-Import Industry – Establishes credibility, emphasizes
            global trade networks, ensures compliance, and attracts business
            clients.
            <br />
            ✅ Textile Industry – Showcases quality, attracts buyers, promotes
            sustainability, and builds brand identity.
            <br />
            ✅ Real Estate Industry – Establishes market authority, builds
            client confidence, explains services, and attracts investors. */}
            At <b>Nexus Wealth Services</b>, we specialize in delivering comprehensive wholesale procurement solutions 
            across key sectors including the Hotel Industry, Export-Import, Textile, and Real Estate. With a commitment to excellence 
            and a deep understanding of multi-industry demands, we act as your strategic sourcing partner.
            <br />
          </Paragraph>
          <Link to="/Aboutus" onClick={Functionscrooll}>
            <ShopButton type="default">More &gt;&gt;</ShopButton>
          </Link>
          </motion.div>
        </Col>
      </Row>
    </BannerContainer>
  );
};

export default Section3;
